import React from "react";
import { NoDataChartStyle } from "./NoDataChart.styled";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";

ChartJS.register(ArcElement, Tooltip, Legend);

const NoDataChart2 = ({ datasetIdKey, module = "" }) => {
  const labelfunction = () => {
    return `Total No of ${module} : 0`;
  };

  return (
    <NoDataChartStyle>
      <p className="chartheading">{module}</p>
      <div className="chartdiv">
        <Doughnut
          datasetIdKey={datasetIdKey}
          options={{
            plugins: {
              tooltip: {
                callbacks: {
                  label: labelfunction,
                },
              },
            },
          }}
          data={{
            labels: ["Confirmed", "Un-Confirmed"],
            fill: false,
            datasets: [
              {
                label: "No Data Available",
                data: [1],
                backgroundColor: ["#808080"],
                hoverOffset: 4,
              },
            ],
          }}
        />
      </div>
    </NoDataChartStyle>
  );
};

export default NoDataChart2;
